(function($) {
    $(window).scroll(function() {
      if ( $(this).scrollTop() > 0 ) {
          $('body').addClass('scroll-active');
      } else {
          $('body').removeClass('scroll-active');
      }
    });

    var $team_carousel = $(".teams-columns__right .carousel__slides").flickity({
      adaptiveHeight: !1,
      cellSelector: '.carousel__slide',
      pageDots: !1,
      prevNextButtons: !1,
      setGallerySize: !1,
      wrapAround: !0,
      cellAlign: 'left',
    });

    $(".teams-columns__right .mobile-carousel__pagination-arrow--prev").click(function(e){
      e.preventDefault();
      $team_carousel.flickity("previous");
    })
    $(".teams-columns__right .mobile-carousel__pagination-arrow--next").click(function(e){
      e.preventDefault();
      $team_carousel.flickity("next");
    })

    $(".close-nav").click(function(){
      $(".drawer-menu").removeClass("visible active");
    });

    $(".drawer-menu__overlay").click(function(){
      $(".drawer-menu").removeClass("visible active");
    });

    $('ul.tabs').each(function() {
      $(this).find('> li').each(function(index) {
          $(this).addClass('tab-control tab-control-'+index);
      });
    });

    $('.open-item').click(function(e) {
      e.preventDefault();

      var $this = $(this);

      if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.next().slideUp(350);
          $this.hasClass('active');
          $this.removeClass('active');
      } else {
          $this.parent().parent().find('li .inner').removeClass('show');
          $this.parent().parent().find('li .inner').slideUp(350);
          $this.next().toggleClass('show');
          $this.next().slideToggle(350);
          $this.parent().parent().find('li .open-item').removeClass('active');
          $this.toggleClass('active');
      }
    });

    $('.tabs-content').each(function() {
      $(this).find('> li').each(function(index, i) {
          var $li = $(this).parent().prev().find('> li.tab-control-'+index);
          $li.after($(this).addClass('content-tab'));
          $li.append('<span class="icon plus">+</span><span class="icon minus">_</span>');
      });
    });

    $('.tab-control a').click(function(e) {
      e.preventDefault();
      $('.content-tab').slideUp();
      if ($(this).parent().hasClass('active')) {
          $('.tab-control').removeClass('active');
      } else {
          $('.tab-control').removeClass('active');
          $(this).parent().addClass('active').next().slideDown();
      }
    });

    $('.tabgroup > div').css({"opacity": "0", "height": "0", "overflow": "hidden"});
    $('.tabgroup > div:first-of-type').css({"opacity": "1", "height": "auto"});

    // Attentive Init
    // window.setTimeout(function() {
    //     var s = document.createElement('script'); // Create a script element
    //     s.type = "text/javascript";               // optional in html5
    //     s.async = true;                           // asynchronous? true/false
    //     s.src = "//cdn.attn.tv/kirrinfinch/dtag.js?shop=kirrin-finch.myshopify.com";
    //     var fs = document.getElementsByTagName('script')[0];  // Get the first script
    //     fs.parentNode.insertBefore(s, fs);
    // }, 4000);

    // Klaviyo Init
    function initKlaviyo() {
        var s = document.createElement('script'); // Create a script element
        s.type = "text/javascript";               // optional in html5
        s.async = true;                           // asynchronous? true/false
        s.src = "//static.klaviyo.com/onsite/js/klaviyo.js?company_id=QkCWPk&shop=kirrin-finch.myshopify.com";
        s.onload = function() {
          // klaviyo event tracking for add to cart and quick add to cart
          var _learnq = _learnq || [];

          document.querySelectorAll("[data-add-to-cart]").forEach(item => {
            item.addEventListener('click', event => {
              //handle click
              _learnq.push(['track', 'Added to Cart', item]);
            });
          });

          document.querySelectorAll("[data-quick-add]").forEach(item => {
            item.addEventListener('click', event => {
                window.setTimeout(function() {
                    document.querySelectorAll("[data-add-to-cart]").forEach(item => {
                        item.addEventListener('click', event => {
                            //handle click
                            _learnq.push(['track', 'Added to Cart', item]);
                        })
                    });
                }, 500);
            });
          });
        };

		document.body.appendChild(s);
        document.removeEventListener('scroll', initKlaviyo);
        document.removeEventListener('mousemove', initKlaviyo);
        document.removeEventListener('touchstart', initKlaviyo);
    }
      document.addEventListener('scroll', initKlaviyo, { once: true });
      document.addEventListener('mousemove', initKlaviyo, { once: true });
      document.addEventListener('touchstart', initKlaviyo, { once: true });

  // Size Guide Tab
  $(".design-tabs a").click(function(e){
  	e.preventDefault();
    if(!$(this).attr("href").includes("#")) {
      window.location.href = $(this).attr("href");
	}
    $(this).closest(".design-tabs").find("a.active").removeClass("active");
    $(this).addClass("active");
    const target = $(this).attr("href").replace("#", "");
    $(this).closest(".tabs-area").find("section.tabgroup  > div").each(function(){
      if($(this).attr("id") == target) {
      	$(this).css({
          "opacity": 1,
          "height": "auto"
        });
      } else {
      	$(this).css({
          "opacity": 0,
          "height": 0
        });
      }
	});
  })

  $('body').on('click', '.quick-cart__configure .quick-add__form [data-button]', function(event) {
    var $this = $(this),
        $parent = $this.closest('[data-option-buttons]'),
        $select = $parent.find('select');

    event.preventDefault();

    var option_value = $this.data('button');
    $parent.find(`[data-button]`).removeClass('selected');
    $parent.find(`[data-button="${option_value}"]`).addClass('selected');
    $select.find(`option`).attr('selected', false);
    $select.find(`option[value="${option_value}"]`).attr('selected', true);
    $select.trigger('change');
    var variantSelectorValue= $('#variant-selector option[data-variant-options="'+option_value+'"]');
    var ship_date = variantSelectorValue.data('available_to_ship_date');
    var available = variantSelectorValue.data('available');
    var quantity = variantSelectorValue.data('quantity');
    $this.closest("[data-product-form]").find("[data-add-to-cart]").removeAttr('data-first-loading');

    jQuery('.ship_date_input').remove();
    jQuery('.ship_date').text('');
    $this.closest("[data-product-form]").find("[data-add-to-cart] span").text('Add to cart');

    if($this.hasClass("sold-out")) {
      const buttonText = $this.closest("[data-product-form]").find("[data-add-to-cart]").attr("data-lang-sold-out");
      $this.closest("[data-product-form]").find("[data-add-to-cart]").prop("disabled", true);
      $this.closest("[data-product-form]").find("[data-add-to-cart] span").text(buttonText);
    } else {
      const buttonText = $this.closest("[data-product-form]").find("[data-add-to-cart]").attr("data-lang-available");
      $this.closest("[data-product-form]").find("[data-add-to-cart]").prop("disabled", false);
      $this.closest("[data-product-form]").find("[data-add-to-cart] span").text(buttonText);
    }

      const primaryLocation = $($this).attr('data-primary-location');
      const secondaryLocation = $($this).attr('data-secondary-location');
      // Only show ship date for pre-orders (not in primary stock)
      const isPreOrder = variantSelectorValue.data('available') && variantSelectorValue.data('quantity') > 0 && ship_date && primaryLocation === 'false' && secondaryLocation === 'true'

      // If product is in stock (primary location), don't show ship date
      if (isPreOrder && primaryLocation !== 'true') {
          jQuery('.ship_date').text('Expected To Ship: ' + ship_date);
          jQuery('.ship_date').after('<input type="hidden" name="properties[Shipping Note]" class="ship_date_input" value="Expected To Ship: ' + ship_date + '">');
          $this.closest("[data-product-form]").find("[data-add-to-cart] span").text('Pre-order');
      }

      if(document.body.querySelector('[data-product-sale-note-json]')){

          const selectedChip = $this;
          let variantID = null;
          if (selectedChip.length > 0) {
              variantID = selectedChip.attr('data-variant');
          }

          const jsonData = JSON.parse(document.body.querySelector('[data-product-sale-note-json]').innerHTML);
          const variantsSaleNotes = jsonData['order_notes'] || {};
          const selectedChipPrimaryLocation = selectedChip.attr('data-primary-location');
          const selectedChipSecondaryLocation = selectedChip.attr('data-secondary-location')

          if(variantID == variantsSaleNotes[variantID].id) {
              const container = $this.closest('.product__details, [data-product-form]');
              const saleNoteProperty = container.find('#sale-note')[0];
              const saleNoteText = container.find('.sale-note-text')[0];
              const saleNoteContainer = container.find('.product-sale-note')[0];

              const isInStock = selectedChipPrimaryLocation === 'true';
              const isPreOrder = selectedChipPrimaryLocation === 'false' && selectedChipSecondaryLocation === 'true';
              const isUnavailable = selectedChipPrimaryLocation === 'false' && selectedChipSecondaryLocation === 'false';
              const productNote = variantsSaleNotes[variantID].product_note;
              const variantNote = variantsSaleNotes[variantID].variant_note;

              // Determine which note to show
              let noteToShow = null;
              if (isUnavailable) {
                  // Completely unavailable - don't show any notes
                  noteToShow = null;
              } else if (isInStock) {
                  // In stock - show product-level note only
                  noteToShow = productNote;
              } else if (isPreOrder) {
                  // Pre-order - show variant note if exists, otherwise product note
                  noteToShow = variantNote || productNote;
              } else {
                  // Default to product note
                  noteToShow = productNote;
              }

              if (noteToShow && noteToShow !== '') {
                  // Show the appropriate note
                  saleNoteProperty.value = noteToShow;
                  saleNoteText.classList.add('active');
                  saleNoteText.innerHTML = noteToShow;
                  saleNoteContainer.style.display = 'block';
              } else {
                  // No note to show - hide
                  saleNoteProperty.value = '';
                  saleNoteText.classList.remove('active');
                  saleNoteContainer.style.display = 'none';
              }

          }
      }
  });

  function moveGorgiasBeforeReactAttaches() {
        var targetLocation = document.querySelector(".header__links-list.fs-body-base");

        if (!targetLocation) return;

        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1 &&
                        (node.id === 'gorgias-chat-container' ||
                            node.getAttribute('data-gorgias-chat-app'))) {
                            targetLocation.insertAdjacentElement('afterend', node);
                            observer.disconnect();
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    moveGorgiasBeforeReactAttaches();

    function addOutlineForChatButton() {
        const intervalId = setInterval(() => {
            const iframe = document.querySelector("iframe#chat-button");
            if (!iframe) return;

            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            if (!iframeDoc) return;

            const chatButton = iframeDoc.querySelector("#gorgias-chat-messenger-button");
            if (!chatButton) return;

            const style = iframeDoc.createElement("style");
            style.textContent = `
                  #gorgias-chat-messenger-button:focus-visible {
                    outline: 2px solid red;
                    outline-offset: 1px;
                 }
            `;
            iframeDoc.head.appendChild(style);

            clearInterval(intervalId);
        }, 300);

        // Stop trying after 10 seconds
        setTimeout(() => {
            clearInterval(intervalId);
        }, 10000);
    }

    addOutlineForChatButton();

    function removeTabIndexFromChatCampaigns() {
        const intervalId = setInterval(() => {

            const chatCampaigns = document.querySelector("#chat-campaigns");
            if (chatCampaigns) {
                chatCampaigns.setAttribute("tabindex", "-1");
                clearInterval(intervalId);
            }
        }, 300);

        // Stop trying after 10 seconds
        setTimeout(() => {
            clearInterval(intervalId);
        }, 10000);
    }

    removeTabIndexFromChatCampaigns();

  var resizeIntervalCount = 0;
  var resizeInterval = setInterval(function() {
    window.dispatchEvent(new Event('resize'));
    resizeIntervalCount++
    // console.log("resizeInterval:", resizeIntervalCount);
    if (resizeIntervalCount >= 60) {
      clearInterval(resizeInterval);
    }
  }, 500);
})(jQuery);
